export default __webpack_public_path__ + "static/media/blocking-flickers.94f8adc9.svg";